import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { RoleWithPermissions } from '../../../../shared/model-typings';

//  Actual function to fetch roles.
//  Note that this endpoint returns Roles with permissions (for whatever reason).
function fetchRoles() {
  return get<RoleWithPermissions[]>('/api/roles');
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
export const rolesQueryKey: QueryKey = ['roles'];

/**
 * useRoles is a hook that fetches and returns the role the
 * current user has access to from /api/roles.
 */
export default function useRoles() {
  return useQuery<RoleWithPermissions[]>({
    queryKey: rolesQueryKey,
    queryFn: fetchRoles,
    staleTime: 1000 * 60 * 1,
  });
}
